var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<div class=\"notifications-container\" ng-if=\"notifications.length\">\n<div class=\"{{note.type}}\" ng-repeat=\"note in notifications\">\n<span class=\"message\" compile-html=\"note.message\" data-dd-privacy=\"mask\"></span>\n<span class=\"icon icon-close close-click\" ng-click=\"close($index)\"></span>\n</div>\n</div>\n";
var id1="/app/global/common/templates/notification.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;